import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../AppContext";
import { logActivity, getTeamIds } from "../utils";
import "./Pipeline.css";
import { PipelineButtonContext } from "./PipelineButtonContext";
import switchTeam from "../../assets/switchTeamSvg";

const PipelineButtons = () => {
  const {
    userEmail,
    userName,
    userCompany,
    userType,
    setClientSelection,
    makeKey,
    matrixData,
    teamMemberSelected,
    teamPermissions,
    path,
    setPath,
    pendingClientCount,
    preapprovedClientCount,
    transactionsUnderContractCount,
    setTeamFilter,
    userCompanyId,
    teamArray,
    setTeamArray,
  } = useContext(AppContext);

  const { buttonSelected, setButtonSelected } = useContext(
    PipelineButtonContext
  );

  useEffect(() => {
    setButtonSelected(path.replace(/[^a-zA-Z ]/g, ""));
  }, [path]);

  const preapprovedClientVolume =
    matrixData[0].Request === "No Request"
      ? null
      : JSON.parse(matrixData[0]["Clients"])
          .filter((e) => {
            return e.MtgPlanner_CRM__Stage__c === "Pre-Approved";
          })
          .reduce((sum, e) => Number(e.Max_Pre_Approval__c) + sum, 0);
  const transactionsUnderContractData =
    matrixData[0].Request === "No Request"
      ? null
      : JSON.parse(matrixData[0]["UnderContract"]).filter(
          (e) =>
            e.MtgPlanner_CRM__Status__c === "Under Contract" ||
            e.MtgPlanner_CRM__Status__c === "Registered" ||
            e.MtgPlanner_CRM__Status__c === "Submitted" ||
            e.MtgPlanner_CRM__Status__c === "Suspended" ||
            e.MtgPlanner_CRM__Status__c === "Conditionally Approved" ||
            e.MtgPlanner_CRM__Status__c === "Clear to Close" ||
            e.MtgPlanner_CRM__Status__c === "Docs Out" ||
            e.MtgPlanner_CRM__Status__c === "Closed"
        );
  const transactionsUnderContractVolume =
    matrixData[0].Request === "No Request"
      ? null
      : transactionsUnderContractData.reduce(
          (sum, e) => Number(e.MtgPlanner_CRM__Purchase_Price__c) + sum,
          0
        );

  function formatCurrency(number) {
    const formattedNumber = number.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return `$${formattedNumber}`;
  }

  function runGetTeamIds() {
    if (!teamArray[0]["Id"]) {
      getTeamIds({
        apiKey: makeKey,
        userCompanyId: userCompanyId,
        teamPermissions: teamPermissions,
        setTeamArray: setTeamArray,
      });
    }
  }

  const preapprovedClientVolumeFormatted =
    matrixData[0].Request === "No Request"
      ? null
      : formatCurrency(preapprovedClientVolume.toString());
  const transactionsUnderContractVolumeFormatted =
    matrixData[0].Request === "No Request"
      ? null
      : formatCurrency(transactionsUnderContractVolume.toString());
  const pipelineButtons = (
    <>
      {teamPermissions ? (
        <div
          className={`account-title pipeline`}
          onClick={() => {
            setTeamFilter("");
            runGetTeamIds();
          }}
        >
          <div className={`team-member select`}>
            {switchTeam}
            &nbsp;
            {teamMemberSelected === userName ? (
              <>
                My&nbsp;<b>Pipeline</b>
              </>
            ) : (
              `${teamMemberSelected}`
            )}
          </div>
        </div>
      ) : userEmail ? (
        <div className={`account-title pipeline`}>
          <div className={`team-member`}>
            My&nbsp;<b>Pipeline</b>
          </div>
        </div>
      ) : (
        false
      )}
      <div className={`pipeline-panels`}>
        <div
          className={`panel withSnapshot ${
            buttonSelected == "pending" ? "selected" : ""
          }`}
          onClick={() => {
            setPath("/pending");
            setButtonSelected("pending");
            setClientSelection("Pending");
            logActivity({
              apiKey: makeKey,
              userEmail: userEmail,
              userType: userType,
              action: "Pending Clients Button",
              tab: "Account",
              userCompany: userCompany,
            });
          }}
        >
          <div>Pending Clients</div>
          <div className="snapshot">{pendingClientCount}</div>
        </div>
        <div
          className={`panel withSnapshot ${
            buttonSelected == "preapproved" ? "selected" : ""
          }`}
          onClick={() => {
            setPath("/preapproved");
            setClientSelection("Pre Approved");
            setButtonSelected("preapproved");
            logActivity({
              apiKey: makeKey,
              userEmail: userEmail,
              userType: userType,
              action: "Pre Approved Clients Button",
              tab: "Account",
              userCompany: userCompany,
            });
          }}
        >
          <div className="withSnapShotLeft">
            <div>Pre-Approved Clients</div>
            {userType !== "Agent" ? null : (
              <div className="snapshotVolume">
                Volume: {preapprovedClientVolumeFormatted}
              </div>
            )}
          </div>
          <div className="snapshot">{preapprovedClientCount}</div>
        </div>
        <div
          className={`panel withSnapshot ${
            buttonSelected == "undercontract" || buttonSelected == "home"
              ? "selected"
              : ""
          }`}
          onClick={() => {
            setPath("/undercontract");
            setButtonSelected("undercontract");
            logActivity({
              apiKey: makeKey,
              userEmail: userEmail,
              userType: userType,
              action: "Current Transactions Button",
              tab: "Account",
              userCompany: userCompany,
            });
          }}
        >
          <div className="withSnapShotLeft">
            <div>Current Transactions</div>
            {userType !== "Agent" ? null : (
              <div className="snapshotVolume">
                Volume: {transactionsUnderContractVolumeFormatted}
              </div>
            )}
          </div>
          <div className="snapshot">{transactionsUnderContractCount}</div>
        </div>
      </div>
    </>
  );

  return <>{pipelineButtons}</>;
};

export default PipelineButtons;
